angular.module('unica_feedback_category.feedback_category_services')

.factory('FeedbackCategoryCreateService', function ($http, getBaseApiURL) {

	var feedbackCategoryCreateService = {};

	feedbackCategoryCreateService.create = function ( feedbackCategoryData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback-category/create',
			data: feedbackCategoryData
		}).then(function(result) {

			if ( result ) {
				return result.data.category;
			}

		});
 
	};

	return feedbackCategoryCreateService;
});